import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '@service/global/global.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface YearConfig {
  id: number;
  year: number;
  isActive: boolean;
  weekends: string[];
}

@Injectable({
  providedIn: 'root',
})
export class HolidayService {
  HolidayApi = this.globalService.apiURL_UPGParticipantSelection + '/holiday';

  constructor(
    private readonly http: HttpClient,
    private readonly globalService: GlobalService,
  ) {}

  // holiday calendar
  getHolidayCalendar(
    year: number,
    holidayEventId?: string,
    fromDate?: string,
    toDate?: string,
    excludeWeekend: boolean = false,
    excludeCanceled: boolean = false,
  ): Observable<any> {
    let params = new HttpParams()
      .set('holiday_years', year.toString())
      .set('exclude_weekend', excludeWeekend.toString())
      .set('exclude_canceled', excludeCanceled.toString());

    if (holidayEventId) {
      params = params.set('holiday_event_id', holidayEventId);
    }
    if (fromDate) {
      params = params.set('from_date', fromDate);
    }
    if (toDate) {
      params = params.set('to_date', toDate);
    }

    return this.http.get(this.HolidayApi + '/all', { params }).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  /// holiday years

  getAllHolidayYears(): Observable<any> {
    return this.http.get(this.HolidayApi + '/year' + '/all').pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  cloneYear(payload: any): Observable<any> {
    return this.http.post(this.HolidayApi + '/year' + '/clone', payload).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  yearStatusChange(yearId: number, isActive: boolean): Observable<any> {
    const body = { is_active: isActive };
    return this.http
      .patch(this.HolidayApi + '/year/' + yearId + '/active-inactive', body)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  addHolidayYear(payload: any): Observable<any> {
    return this.http.post(this.HolidayApi + '/year', payload).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getConfigByYear(year: number): Observable<any> {
    return this.http.get(this.HolidayApi + '/year/' + year).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  updateConfig(year: number, payload: any): Observable<any> {
    return this.http
      .patch(this.HolidayApi + '/year' + '/weekend-setup/' + year, payload)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  // holiday event start //

  createHolidayEvent(body: any): Observable<any> {
    return this.http.post(this.HolidayApi + '/event', body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAllHolidayEvent(): Observable<any> {
    return this.http.get(this.HolidayApi + '/event/' + 'all').pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAllHolidayEventById(Id: string): Observable<any> {
    return this.http.get(this.HolidayApi + '/event/' + Id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  updateHolidayEventById(Id: string, body: any): Observable<any> {
    return this.http.patch(this.HolidayApi + '/event/' + Id, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  deleteHolidayEvent(Id: string): Observable<any> {
    return this.http.delete(this.HolidayApi + '/event/' + Id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  // holiday event ends //

  // holiday //

  createHoliday(body: any): Observable<any> {
    return this.http.post(this.HolidayApi, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  updateHoliday(year, eventId, Id, body: any): Observable<any> {
    return this.http
      .patch(
        this.HolidayApi +
          '/holiday-year/' +
          year +
          '/holiday-event/' +
          eventId +
          '/id/' +
          Id,
        body,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }
}
